import { P, rem, Spacer, theme, WarningIcon } from 'design-system';

import { Section, SectionInner } from '../components/section';

export const MacrosBanner = () => {
  return (
    <Section
      css={{
        backgroundColor: theme.colors.yellow3,
      }}
    >
      <Spacer height={24} />
      <SectionInner
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <P
          size="medium"
          css={{
            color: theme.colors.yellow11,
            fontWeight: theme.fontWeights.medium,
            display: 'flex',
            gap: rem(12),
            alignItems: 'center',
          }}
        >
          <WarningIcon width={rem(18)} />
          Unfortunately, we had to remove all macros from your uploaded
          manuscript
        </P>
      </SectionInner>
      <Spacer height={24} />
    </Section>
  );
};
